import Vue from 'vue'
import debounce from 'lodash/debounce'

Vue.prototype.$keypressNumber = (evt) => {
  const event = (evt) || window.event
  const charCode = (event.which) ? event.which : event.keyCode
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    event.preventDefault()
    return false
  }
  return true
}

Vue.prototype.$keypressNumberNoDecimal = (evt) => {
  const event = (evt) || window.event
  const charCode = (event.which) ? event.which : event.keyCode
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
    event.preventDefault()
    return false
  }
  return true
}

Vue.prototype.$keypressTelInput = (evt) => {
  const event = (evt) || window.event
  const charCode = (event.which) ? event.which : event.keyCode
  if (((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) && charCode !== 43) {
    event.preventDefault()
    return false
  }
  return true
}

const cdnUrl = process.env.VUE_APP_CDN_URL
const imgixUrl = process.env.VUE_APP_S3_IMGIX
const s3Url = 'https://new-gentlewoman.s3.ap-southeast-1.amazonaws.com'
const s3Cdn = 'https://new-gentlewoman.s3-ap-southeast-1.amazonaws.com'

const parseQueryString = (url) => {
  const [path, query] = url.split('?')
  return [path, Object.fromEntries(new URLSearchParams(query))]
}

const parseQueryObject = (queryObject) => {
  const combined = Object.keys(queryObject).reduce((acc, key) => [...acc, `${key}=${queryObject[key]}`], [])
  return `${combined.join(',')}`
}

const convertImgix = (url) => {
  if (!url) {
    return ''
  }

  const isS3Url = url.startsWith(s3Url)
  const isImgixUrl = url.startsWith(imgixUrl)
  const [path, query] = parseQueryString(url)

  if (query?.fm === 'mp4') {
    return url
  }

  const availableOptions = {
    fm: 'format',
    q: 'quality',
    w: 'width',
    h: 'height',
    fit: 'fit'
  }
  const options = {}
  Object.keys(query).forEach((key) => {
    if (availableOptions[key] && key === 'ar' && query.w && query.h) {
      options[availableOptions[key]] = Number((Number(query.w) / Number(query.h)).toFixed(2))
    } else if (availableOptions[key]) {
      options[availableOptions[key]] = query[key]
    }
  })

  if (isS3Url) {
    return `${cdnUrl}/${parseQueryObject(options)}/${path.replace(s3Url, s3Cdn)}`
  }
  if (isImgixUrl) {
    return `${cdnUrl}/${parseQueryObject(options)}/${s3Cdn}${path.replace(imgixUrl, '')}`
  }

  return url
}

Vue.prototype.$convertImgix = convertImgix
Vue.prototype.$debounce = debounce
